export const leggieKickstandOptionValues = [
    {
        label: 'woom GO/ORIGINAL 1 PLUS',
        value: 's:woom-original-1-plus',
    },
    {
        label: 'woom GO/ORIGINAL 2',
        value: 's:woom-original-2',
    },
    {
        label: 'woom GO/ORIGINAL 3',
        value: 's:woom-original-3',
    },
    {
        label: 'woom GO/ORIGINAL 3 Automagic',
        value: 's:woom-original-3-automatic',
    },
    {
        label: 'woom GO/ORIGINAL 4',
        value: 'm:woom-original-4',
    },
    {
        label: 'woom ORIGINAL 5',
        value: 'm:woom-original-5',
    },
    {
        label: 'woom ORIGINAL 6',
        value: 'l:woom-original-6',
    },
    {
        label: 'woom EXPLORE 4',
        value: 'm:woom-explore-4',
    },
    {
        label: 'woom EXPLORE 5',
        value: 'm:woom-explore-5',
    },
    {
        label: 'woom EXPLORE e 5',
        value: 'm:woom-explore-e-5',
    },
    {
        label: 'woom EXPLORE 6',
        value: 'l:woom-explore-6',
    },
    {
        label: 'woom EXPLORE e 6',
        value: 'l:woom-explore-e-6',
    },
    {
        label: 'woom OFF 4',
        value: 'm:woom-off-4',
    },
    {
        label: 'woom OFF 5',
        value: 'l:woom-off-5',
    },
    {
        label: 'woom OFF 6',
        value: 'l:woom-off-6',
    },
    {
        label: 'woom OFF AIR 4',
        value: 'm:woom-off-air-4',
    },
    {
        label: 'woom OFF AIR 5',
        value: 'l:woom-off-air-5',
    },
    {
        label: 'woom OFF AIR 6',
        value: 'l:woom-off-air-6',
    },
    {
        label: 'woom UP 5',
        value: 'l:woom-up-5',
    },
    {
        label: 'woom UP 6',
        value: 'l:woom-up-6',
    },
];
